// extracted by mini-css-extract-plugin
export var askAiIcon = "_pb-9";
export var container = "_pb-0";
export var groupSeparator = "_pb-a";
export var highlight = "_pb-4";
export var resultIcon = "_pb-5";
export var resultItem = "_pb-7";
export var resultSubtitle = "_pb-3";
export var resultTitle = "_pb-2";
export var resultsList = "_pb-1";
export var searchGroup = "_pb-6";
export var selected = "_pb-8";